import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk to fetch localizes data
export const fetchLocalizes = createAsyncThunk("localizes/fetchLocalizes",
  async () => {
    try {
      const result = await axios.get(`${process.env.REACT_APP_CMS_URL}/localizes`, {
        commonHeaderNotRequired: true,
      });
      return result?.data;
    } catch (err) {
      console.log(err);
    }
  }
);

const localizesSlice = createSlice({
  name: "localizes",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearLocalizes: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLocalizes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLocalizes.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchLocalizes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearLocalizes } = localizesSlice.actions;
export default localizesSlice.reducer; 